<template>
  <div class="recurrence" :class="{ compact }">
    <BaseButton
      v-if="!disabled"
      :tabindex="-1"
      kind="auxiliary"
      :state="disabled ? 'disabled' : 'default'"
      :text="recurrenceDisplay.text"
      :tooltip-display="recurrenceDisplay.tooltip ? 'always' : 'none'"
      :tooltip="recurrenceDisplay.tooltip"
      @click="onClick"
    >
      <template #icon>
        <RecurringIcon />
      </template>
    </BaseButton>
    <BaseButton
      v-else
      kind="auxiliary"
      state="disabled"
      :text="recurrenceDisplay.text"
      :tooltip-display="recurrenceDisplay.tooltip ? 'always' : 'none'"
      :tooltip="recurrenceDisplay.tooltip"
    >
      <template #icon>
        <RecurringIcon />
      </template>
    </BaseButton>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, PropType, Ref, toRefs } from "vue";

import { Recurrence } from "@ctrl/controller-rpc";

import BaseButton from "@/components/base/BaseButton.vue";
import RecurringIcon from "@/components/icons/RecurringIcon.vue";
import {
  getRecurrenceText,
  isWeeklyRecurrenceMultipleDays,
} from "@/components/recurrence";

export default defineComponent({
  components: { BaseButton, RecurringIcon },
  props: {
    compact: {
      type: Boolean,
      defaut: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object as PropType<Recurrence | Array<string>>,
    },
  },
  emits: {
    click: (_: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const { disabled, value } = toRefs(props);
    const recurrenceDisplay: Ref<{
      text: string;
      tooltip: string | undefined;
    }> = computed(() => {
      if (value?.value) {
        return Array.isArray(value.value)
          ? { text: "Complex recurrence", tooltip: undefined }
          : {
              text: isWeeklyRecurrenceMultipleDays(value.value.rule)
                ? "Multiple days"
                : getRecurrenceText(value.value.rule),
              tooltip: isWeeklyRecurrenceMultipleDays(value.value.rule)
                ? getRecurrenceText(value.value.rule)
                : undefined,
            };
      }
      return { text: "No repeat", tooltip: undefined };
    });
    const onClick = (e: MouseEvent) => {
      if (!disabled.value) emit("click", e);
    };
    return { onClick, recurrenceDisplay };
  },
});
</script>
<style lang="scss" scoped>
.recurrence {
  display: flex;
  min-width: 120px;
}
</style>
